import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';

import { ILoanAccountContact } from '../../../interfaces';
import { FormattingUtils } from '../../../utils';

import ContactFormModal from './ContactFormModal';
import SearchContactsModal from './SearchContactsModal';

const { splitName } = FormattingUtils;

interface IProps {
  loanAccountId: string;
  onAssign: (contact: ILoanAccountContact) => Promise<void>;
  onClose: () => void;
  onCreate: (data: object) => Promise<void>;
}

/**
 * Adding a contact in two steps: search the funder's contacts, then either assign the one that turns up
 * or create a new one. The same shape as the case add-contact flow, which asks the same two questions
 * across two pages -- kept in one modal here, the account page's other writes being modals.
 *
 * The name typed into the search carries over into the form, so a contact that turned out not to exist
 * is not typed twice.
 */
@autoBindMethods
@observer
class AddContactModal extends Component<IProps> {
  // The name to start the form from, or null while the search step is still up
  @observable private newContactName: null | string = null;

  private onCreateNew (searchTerm: string) {
    this.newContactName = searchTerm;
  }

  public render () {
    const { loanAccountId, onAssign, onClose, onCreate } = this.props;

    if (this.newContactName === null) {
      return (
        <SearchContactsModal
          loanAccountId={loanAccountId}
          onAssign={onAssign}
          onClose={onClose}
          onCreateNew={this.onCreateNew}
        />
      );
    }

    const [firstName, lastName] = splitName(this.newContactName);

    return (
      <ContactFormModal
        contact={{ first_name: firstName, last_name: lastName }}
        onClose={onClose}
        onSave={onCreate}
      />
    );
  }
}

export default AddContactModal;
